import styled from 'styled-components';

import { Icon as SemanticIcon } from 'semantic-ui-react';
import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const ContainerCardClip = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  ${(props) => props.isSelectable && 'cursor: pointer;'}
  ${(props) => (props.selected
  ? 'box-shadow: 0px 0px 0px 2px #89E27E inset;'
  : 'box-shadow: 0px 0px 0px 1px #DEDEDF inset;'
)}
  margin-bottom:20px;
  padding: 10px;
  border-radius: 4px;
`;

export const TitleCard = styled(TextLayoutComponent)`
  font-size: 16px;
  font-weight: 500;
  color: #192c47;
  margin-bottom: 10px;
`;

export const NoteCard = styled(TextLayoutComponent)`
  font-size: 14px;
  color: #4D5573;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
`;

export const CardClipFooter = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 15px 0 5px 0;
`;

export const DateCard = styled(NoteCard)`
  margin: 0;
`;

export const CardLink = styled.a`
  font-weight: 500;
`;

export const StatusProcessing = styled(TextLayoutComponent)`
  font-weight: 400;
  color: #E99484;
`;

// display: unset - For this icon not to go over the search bar in Safari
export const Icon = styled(SemanticIcon)`
  &&& {
    display: unset;
    margin-left: 5px;
  }
`;
